module.exports = __webpack_public_path__ + "static/media/03_music-module.e3a81fdf.mp4";